import { useEffect, useState } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { DropdownField, Heading, Modal, ModalControlModalProps, Text, useFormField } from '@frontend/design-system';

type Props = {
  modalProps: ModalControlModalProps;
  locationIds: string[];
  onClick: (locationId: string) => void;
  isCreateContact?: boolean;
};

export const LocationSelectorModal = ({ modalProps, locationIds, onClick, isCreateContact }: Props) => {
  const { t } = useTranslation('fax');
  const { getScopeName } = useAppScopeStore();
  const [selectedLocationId, setSelectedLocationId] = useState<string>();

  const locationFieldProps = useFormField({
    type: 'dropdown',
    value: '',
  });

  useEffect(() => {
    if (locationFieldProps.value) {
      setSelectedLocationId(locationFieldProps.value);
    }
  }, [locationFieldProps.value]);

  return (
    <Modal {...modalProps} maxWidth={480}>
      <Modal.Body>
        <div
          css={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: theme.spacing(2),
          }}
        >
          <Heading level={2}>{t('Select a Location')}</Heading>
        </div>

        <Text
          css={{
            marginBottom: theme.spacing(2),
          }}
        >
          {isCreateContact
            ? t('Select the location you are creating a contact for.')
            : t('Select the location you are sending this fax from.')}
        </Text>
        <DropdownField name='location' label={t('Select Location')} {...locationFieldProps}>
          {locationIds.map((locationId) => {
            const locationName = getScopeName(locationId);

            return (
              <DropdownField.Option key={locationId} value={locationId}>
                {locationName}
              </DropdownField.Option>
            );
          })}
        </DropdownField>
      </Modal.Body>
      <Modal.Footer
        primary={{
          label: t('Next'),
          onClick: () => {
            onClick(selectedLocationId ?? '');
            modalProps.onClose();
          },
          disabled: !selectedLocationId,
        }}
        secondary={{ label: t('Cancel'), onClick: modalProps.onClose }}
      />
    </Modal>
  );
};
